export default __webpack_public_path__ + "assets/images/2bb5d230b0e0890a32a96fde9b9003a9.jpg";